import axios from "axios";
import store from "../redux/store";
import { showToastAction } from "../redux/toastSlice";

export default async function getMonitoringData() {
    try {
        const res = await axios.get("/admin-dashboard/project-usage-kpis");
        return res.data;
    }
    catch (err) {
        store.dispatch(showToastAction({ message: err.response?.data?.errorMessage ?? "Error", showToast: true }))
    }
}